import { Component, OnInit,ViewChild } from '@angular/core';
import { ItemService } from 'app/shared/services/item.service';
import { Item } from 'app/shared/types/item';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from 'app/shared/services/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from 'app/shared/services/auth.service';
import { EnvService } from '../../../shared/services/env.service';

@Component({
  selector: 'app-item-list',
  templateUrl: './item-list.component.html',
  styleUrls: ['./item-list.component.css']
})

export class ItemListComponent implements OnInit {

  displayedColumns: string[] = ['itemcode', 'description','unitPrice','rol','qtyBal','createdBy','action'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  isDark: boolean = false;

  item : Item[];

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };
  
  statusCode: number;

  constructor(private itemService : ItemService,
              private dialogService : DialogService,
              private router : Router, 
              private toastr: ToastrService,
              private route: ActivatedRoute,
              private themeService: NbThemeService,
              private authService: AuthService,
              private env: EnvService
              ) { }

  ngOnInit() {
    this.getAllItems();
    this.getControlPermissions();

    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });
  }

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='IM'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }

  newButtonClick(){
   this.itemService.dataRow = null;
   this.router.navigate(['../item'],{relativeTo : this.route});
   

  }
  
getAllItems(){
    this.itemService.getAll()
     .subscribe(
        (data) => {
                  this.item = data;
                  this.dataSource = new  MatTableDataSource (this.item );  
                  this.dataSource.sort = this.sort;
                  this.dataSource.paginator = this.paginator;  
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                 });  
       
     }

     getRowData(row){   
      this.itemService.dataRow = row;  
      this.router.navigate(['../item'],{relativeTo : this.route});
   }
        
   
   deleteButtonClick(itemCode : string){
          this.dialogService.openConfirmDialog('Are you sure you want to delete this record?')
          .afterClosed().subscribe(res =>{
            if(res){
              this.itemService.deleteItem(itemCode)
            .subscribe(
              (res) => {
                          this.toastr.success('Item was deleted successfully','Success');
                          this.getAllItems();
                          console.log(res);     
                        },        
              (err) =>  {
                          this.toastr.error('Failed to delete item','Failure');
                          if(err instanceof HttpErrorResponse){                 
                            if(err.status == 401){
                              this.router.navigate(['/login']);
                            }
                          }
                          console.log(err);
                        }, 
                )
            }
          });            
      }

      applyFilter(){
        this.dataSource.filter =this.searchKey.trim().toLowerCase();

      }
      onSearchClear(){
        this.searchKey = "";
        this.applyFilter();
      }



   

}
